import React, { Component } from 'react'
import { DatePicker, Select } from 'hljd'
import SearchBar from '@common/SearchBar'
import store from '../store'

const RangePicker = DatePicker.RangePicker
const Item = SearchBar.Item
const Option = Select.Option

export default class extends Component {
  render() {
    return (
      <SearchBar store={store}>
        <Item label="订单创建时间" name="created_at">
          <RangePicker />
        </Item>

        <Item label="开票状态" name="invoice_status" initialValue="">
          <Select style={{ width: 120 }}>
            <Option value="">全部</Option>
            <Option value="1">待开票</Option>
            <Option value="2">申请中</Option>
            <Option value="3">审核不通过</Option>
            <Option value="4">已开票</Option>
          </Select>
        </Item>
      </SearchBar>
    )
  }
}
